import React, { FC, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import snakeCase from 'lodash.snakecase';
import { RecommendationsActivityType } from 'src/api/me/types';
import { Toast } from 'src/components';
import * as S from './styles';

const msgs = defineMessages({
  tooltip: { id: 'myActivities_dateRange_tooltip' },
});

export const ActivityStatisticsCard: FC<{
  title: string;
  value: number;
  difference: number;
  type: RecommendationsActivityType;
}> = ({ title, value, difference, type }) => {
  const intl = useIntl();
  const [tooltipOpen, setIsPopoutOpen] = useState(false);
  const toggleTooltip = () => setIsPopoutOpen(!tooltipOpen);
  const isDifferencePositive = difference > 0;
  const isDifferenceNegative = difference < 0;
  const formattedDifference = Math.abs(difference);

  return (
    <S.CardContainer $type={type}>
      <S.CardTitle>{title}</S.CardTitle>

      <S.ValueContainer>
        <S.CardValue data-testid={`my_activities_${snakeCase(title)}_total`}>{value}</S.CardValue>
        {(isDifferencePositive || isDifferenceNegative) && (
          <S.DifferenceContainer onClick={toggleTooltip}>
            <S.DifferenceArrow $isPositive={isDifferencePositive} name="triangle" />
            <S.DifferenceValue>{formattedDifference}</S.DifferenceValue>
          </S.DifferenceContainer>
        )}
      </S.ValueContainer>

      {tooltipOpen && (
        <S.ToastContainer>
          <Toast
            snackBar
            status="info"
            pointedTip="right"
            onClick={toggleTooltip}
            shouldCloseOnOutsideClick
          >
            {intl.formatMessage(msgs.tooltip)}
          </Toast>
        </S.ToastContainer>
      )}
    </S.CardContainer>
  );
};
